<template>
  <div :class="$style.root">
    <img
      :class="[$style.image, (showStartOverButton || !imageSrc) && $style.hidden]"
      :src="imageSrc"
      :alt="imageAlt"
    />

    <UiRepeatedClickCounter
      v-show="clickable"
      :class="[$style.clickCounter, showStartOverButton && $style.hidden]"
      :count="hardRestartClicks"
      :show-after-clicks="hardRestartShowAfter"
      @start="emit('soft-restart')"
      @success="emit('hard-restart')"
    />

    <button
      type="button"
      :class="[$style.startOver, 'kiosk-button', !showStartOverButton && $style.hidden]"
      @click="emit('soft-restart')"
    >
      {{ startOverLabel }}
    </button>
  </div>
</template>

<script setup lang="ts">
// biome-ignore lint/correctness/noUnusedImports: used via tag <UiRepeatedClickCounter> in <template>
import UiRepeatedClickCounter from '../widgets/UiRepeatedClickCounter.vue';

interface Props {
  imageSrc?: string;
  imageAlt?: string;
  showStartOverButton: boolean;
  startOverLabel: string;
  clickable: boolean;
  hardRestartClicks?: number;
  hardRestartShowAfter?: number;
}

withDefaults(defineProps<Props>(), {
  imageSrc: undefined,
  imageAlt: undefined,
  hardRestartClicks: 5,
  hardRestartShowAfter: 3,
});

const emit = defineEmits<{
  'soft-restart': [];
  'hard-restart': [];
}>();
</script>

<style module>
.image {
  display: block;
  width: var(--kiosk-logo-size);
  margin: var(--kiosk-logo-offset-y) 0 0 var(--kiosk-logo-offset-x);
  transform: var(--kiosk-logo-transform);
  transform-origin: var(--kiosk-logo-transform-origin);
}

.clickCounter {
  position: absolute;
  top: var(--kiosk-logo-offset-y);
  left: var(--kiosk-logo-offset-x);
  width: calc(var(--kiosk-logo-size) + 4rem);
  height: calc(100% - var(--kiosk-logo-offset-y));
  display: flex;
  align-items: center;
  justify-content: end;
  cursor: pointer;
}

.startOver {
  position: absolute;
  top: 1rem;
  left: 0.9rem;
}

.hidden {
  display: none;
}
</style>
